import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import type { UAPPlacementComponentProps } from '../../@types';
import { withUAPLThemedStyles } from '../../with-themed-styles';
import { getDynamicSearchAdPlacementStyles } from '../../styles';

import {
  AdLabel,
  PlacementHeadline,
  PlacementFinalUrlWithLink,
  PlacementDescription,
  PlacementContentContainer,
} from '../../shared-components';

export const AdPlacementDynamicSearchPropTypes = {
  propTypes: {
    i18n: PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    classes: PropTypes.shape({
      placementContentContainer: PropTypes.string,
      placementCard: PropTypes.string,
      placementTextContainer: PropTypes.string,
      placementAdsLabel: PropTypes.string,
      placementDisplayUrl: PropTypes.string,
      placementDescriptionContainer: PropTypes.string,
      placementDescription: PropTypes.string,
    }).isRequired,
    previewTexts: PropTypes.shape({
      longHeadline: PropTypes.string,
      description: PropTypes.string,
      displayUrl: PropTypes.string,
      url: PropTypes.string,
    }).isRequired,
  },
  defaultProps: {
  },
};


export const DynamicSearchAdPlacementBase = (props: UAPPlacementComponentProps) => {
  const {
    i18n,
    classes,
    previewTexts: {
      headline,
      description,
      finalUrl,
      displayUrl,
    },
  } = props;

  return (
    <div className={classnames(classes.placementCard, 'ad-placement-card-preview')}>
      <PlacementContentContainer
        placementContentContainerClassName={classes.placementContentContainer}
      >
        <div className={classes.placementTextCardContainer}>
          <div className={classes.placementTextContainer}>
            <PlacementHeadline

              headlineText={headline}
              placementHeadlineClassName={classnames(classes.placementHeadline, 'headline')}
            />
            <PlacementFinalUrlWithLink

              finalUrl={finalUrl}
              displayUrl={displayUrl}
              placementFinalUrlClassName={classnames(classes.placementUrl, 'final-url')}
            />
            <div className={classnames(classes.placementDescriptionContainer, 'descriptions')}>
              <AdLabel i18n={i18n} adsLabelClassName={classes.placementAdsLabel} />
              <PlacementDescription

                description={description}
                placementDescriptionClassName={classes.placementDescription}
              />
            </div>
          </div>
        </div>
        <div className={classes.placementDisclaimer}>
          {i18n.getString(_TL_('Dynamically generated ad'))}
        </div>
      </PlacementContentContainer >
    </div >
  );
};

DynamicSearchAdPlacementBase.propTypes = AdPlacementDynamicSearchPropTypes.propTypes;

DynamicSearchAdPlacementBase.defaultProps = AdPlacementDynamicSearchPropTypes.defaultProps;

export const AdPlacementDynamicSearch = withUAPLThemedStyles(

  (props: UAPPlacementComponentProps) => <DynamicSearchAdPlacementBase {...props} />,
  getDynamicSearchAdPlacementStyles,
  { componentName: 'AdPlacementDynamicSearch' }
);
